import { createTheme } from '@mui/material/styles';
import { tableComponents } from './tableComponents';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#C3FF4D',
      light: '#D4FF7A',
      dark: '#A8D84A',
      contrastText: '#1A1A1A',
    },
    secondary: {
      main: '#666666',
      light: '#8C8C8C',
      dark: '#4D4D4D',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#EF5350',
      light: '#E57373',
      dark: '#C62828',
    },
    warning: {
      main: '#FFA726',
      light: '#FFB74D',
      dark: '#F57C00',
    },
    info: {
      main: '#29B6F6',
      light: '#4FC3F7',
      dark: '#0288D1',
    },
    success: {
      main: '#66BB6A',
      light: '#81C784',
      dark: '#388E3C',
    },
    background: {
      default: '#121212',
      paper: '#1E1E1E',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B0B0B0',
      disabled: '#6D6D6D',
    },
    divider: '#303030',
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    h1: { fontSize: "2.125rem", fontWeight: 700, lineHeight: 1.2 },
    h2: { fontSize: "1.75rem", fontWeight: 600, lineHeight: 1.3 },
    h3: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.25rem", fontWeight: 600, lineHeight: 1.4 },
    h5: { fontSize: "1.1rem", fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: "1rem", fontWeight: 600, lineHeight: 1.5 },
    body1: { fontSize: "0.875rem", lineHeight: 1.5 },
    body2: { fontSize: "0.75rem", lineHeight: 1.5 },
    button: { fontSize: "0.875rem", fontWeight: 600, textTransform: "none" },
    caption: { fontSize: "0.75rem", lineHeight: 1.4 },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    ...tableComponents,
    MuiButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          borderRadius: 4,
          padding: "6px 16px",
          lineHeight: 1.5,
          textTransform: "none",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            boxShadow: "none",
          },
          "&.Mui-disabled": {
            cursor: "not-allowed",
            pointerEvents: "auto",
          },
          "&.MuiButton-containedPrimary": {
            textShadow: "0 0 1px rgba(0,0,0,0.8)",
          },
        },
        sizeSmall: {
          padding: "4px 10px",
          fontSize: "0.8125rem",
        },
        sizeLarge: {
          padding: "8px 22px",
          fontSize: "0.9375rem",
        },
        containedPrimary: {
          "&:hover": {
            boxShadow: "0 2px 8px rgba(195, 255, 77, 0.4)",
          },
        },
        outlined: {
          borderWidth: 1.5,
          "&:hover": {
            borderWidth: 1.5,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          transition: "all 0.2s ease-in-out",
          "&.Mui-disabled": {
            cursor: "not-allowed",
            pointerEvents: "auto",
          },
        },
      },
    },
    MuiDrawer: {
      defaultProps: {
        PaperProps: { elevation: 4 },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: '64px !important',
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiRadio: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiSwitch: {
      defaultProps: {
        size: 'small',
      },
    },
  },
});